import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const TermsOfServiceModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Terms of Service"
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '80vh', // Make the modal scrollable if the content is too long
          fontFamily:'Poppins',
          padding:"5%",
          margin:"0 0.01rem"

        //   marginRight:"15%"
        },
      }}
    >
      <h2>Terms of Service</h2>
      <div className="scrollable-content">
        <h5>Data Collection and Usage</h5>
        <p>
          This application collects and stores the email address and password of its users. Additionally, the app records the date you provide for failing NNN. No other personal information is collected or stored.
        </p>

        <h5>Analytics Data</h5>
        <p>
          Firebase Analytics is used to collect data for the purpose of understanding user interactions with the application. This data is collected and processed by Firebase for analytical purposes to improve the user experience. No personal data beyond what is mentioned above is shared with Firebase Analytics. These services requires the use of cookies. 
          There are no third party cookies other than what firebase stores for authentication(login) and analytics.
        </p>

        <h5>Legal Disclaimer</h5>
        <p>
          This application is provided for recreational and educational purposes only and is not intended for commercial use. The developer assumes no legal responsibility for the usage of this application.
        </p>
      </div>
      <Button onClick={onRequestClose}>Close</Button>
    </Modal>
  );
};

export default TermsOfServiceModal;
